import React, { Component, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Input, Button, Alert } from 'reactstrap';
import Session from '../auth/Session';
import AdminFunctions from './AdminFunctions';
import '../layout/site.css';

function CreateRole(props) {

    const [roleName, setRoleName] = useState('');
    const [success, setSuccess] = useState(undefined);

    useEffect(() => {
        async function fetchIsAdmin() {
            const isAdmin = AdminFunctions.isAdminAsync();
            if (!isAdmin) {
                navigate('/accessdenied');
            }
        }
        fetchIsAdmin();
    })

    const createRole = async () => {
        const token = Session.getToken();

        const response = await fetch(`api/Admin/CreateRoleAsync?roleName=${roleName}`, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const data = await response.json();
        setSuccess(data);
    }

    return (
        <div>
            <Container className='container-main'>
                <Row>
                    <Col>
                        <h3>Create Role</h3>
                    </Col>
                </Row>
                <Row className='row-20'>
                    <Col xl='10'>
                        <Input
                            type='text'
                            onChange={(e) => setRoleName(e.target.value)}
                            name='roleName'
                            id='roleName'
                            placeholder='Role Name'
                        />
                    </Col>
                    <Col xl='2'>
                        <Button
                            color='primary'
                            onClick={() => createRole()}
                        >
                            Create
                        </Button>
                    </Col>
                </Row>
                <Row className='row-20'>
                    <Col>
                        {success === true && (
                            <Alert color='success'>
                                Role added successfully!
                            </Alert>
                        )}
                        {success === false && (
                            <Alert color='danger'>
                                Error adding role!
                            </Alert>
                        )}
                    </Col>
                </Row>
            </Container>
        </div>
    )
}


export default CreateRole